import React from 'react';
import { MainScreen } from './components/MainScreen/MainScreen';
import { ReduxApp } from './components/ReduxApp';

export const App: React.FC = () => (
  <ReduxApp>
    <MainScreen />
  </ReduxApp>
);
